export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const REGISTRATION_ROUTE = '/registration';
export const CONFIRMATION_ROUTE = '/confirmation';
export const PLUGINS_ROUTE = '/plugins';
export const PLUGIN_DETAILS_ROUTE = '/plugin';
export const SERVERS_ROUTE = '/servers';
export const SERVER_PLUGINS_ROUTE = '/server/plugins';
export const CREATE_SERVER = '/server/create';
export const CHAT_ROUTE = '/chat';
export const LOG_ROUTE = '/log';
export const SERVER_DETAILS = '/details';
export const CHAT_PAGE = '/chatpage';
export const CONFIG_EDIT = '/configedit';
export const SERVER_SETTINGS = '/server-settings';
export const SERVER_SHOP_CATEGORIES = '/server-shop-categories';
export const SERVER_SHOP_ITEMS = '/server-shop-items';
export const SHOP_ITEMS = '/shop-items';
export const SERVER_PLAYERS = '/players';
export const WALLET_PLAYER = '/wallet';
export const USER_CABINET_ROUTE = '/user-cabinet';
export const RULES = '/rules';
export const LEGAL_ROUTE = '/legal';
